import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import toastr from "toastr";
import i18n from "@Shared/@i18n";
import Vue from "vue";
import { isEmpty } from "lodash";
export const ENVIRONMENT = process.env.ENVIRONMENT;
export const VERSION = process.env.VERSION;
export const ERROR_HEADER = "ERROR_HEADER";
export const CHECK_MESSAGE_E = "CHECK_MESSAGE_E";
export const LOADING_MESSAGE_E = "LOADING_MESSAGE_E";
export const SUBMIT_MESSAGE_E = "SUBMIT_MESSAGE_E";
export const DOCUMENT_SUCCESS = "DOCUMENT_SUCCESS";
export const PROGRESS_MESSAGE_E = "PROGRESS_MESSAGE_E";
export const ERROR_SPAN = `ERROR_SPAN`;
export const DUPLICATED_DOMAIN = "DUPLICATED_DOMAIN";
export const BROKER_PORTAL_THEMES = {
  strawberry: {
    primary: "#d3475a",
    secondary: "#87092a"
  },
  night: {
    primary: "#3b3c60",
    secondary: "#e4986f"
  },
  evergreen: {
    primary: "#21ce99",
    secondary: "#1696a2"
  },
  valencia: {
    primary: "#f0941e",
    secondary: "#bc3e0c"
  },
  wine: {
    primary: "#c137a2",
    secondary: "#694ed6"
  },
  azure: {
    primary: "#00a0f9",
    secondary: "#1b7cdf"
  }
};
export const REGISTRATION_FORM_FIELDS = ["familyName", "givenName", "email", "phoneNumber", "licenseId", "name", "franchise"];
export const CALCULATOR_PATHS = {
  maximumMortgageCalcs: "maximum-mortgage-calcs",
  mortgageIsolatorCalcs: "mortgage-isolator-calcs",
  paymentAnalyzerCalcs: "payment-analyzer-calcs",
  prepaymentAnalyzerCalcs: "prepayment-analyzer-calcs",
  scenarioBuilderCalcs: "scenario-builder-calcs",
  minimumIncomeCalcs: "minimum-income-calcs",
  rentBuyAnalyzerCalcs: "rent-buy-analyzer-calcs",
  mortgageAnalyzerCalcs: "mortgage-analyzer-calcs",
  amortizationScheduleCalcs: "amortization-schedule-calcs"
};
export const PLAN_NAMES = {
  FREE: "free",
  PRO: "professional"
};
export const PREDEFINED_PAYMENT_PLANS = () => {
  var _context, _context2, _context3;
  return [{
    key: "free",
    name: PLAN_NAMES.FREE,
    label: "plus",
    amount: 0,
    perks: _mapInstanceProperty(_context = [i18n.t("account.accountPlan.perks.dealAndManagement"), i18n.t("account.accountPlan.perks.applicationPortal"), i18n.t("account.accountPlan.perks.intuitiveDashboard"), i18n.t("account.accountPlan.perks.automatedLenderNotes"), i18n.t("account.accountPlan.perks.automatedClientEmailSummaries"), i18n.t("account.accountPlan.perks.smartEmailDrafts"), i18n.t("account.accountPlan.perks.documentDataExtraction"), i18n.t("account.accountPlan.perks.secureDocumentStorage"), i18n.t("account.accountPlan.perks.integratedCustomerSupport"), i18n.t("account.accountPlan.perks.referralTool"), i18n.t("account.accountPlan.perks.reporting"), i18n.t("account.accountPlan.perks.directToLender"), i18n.t("account.accountPlan.perks.autoSync")]).call(_context, e => e.toString()),
    missingPerks: _mapInstanceProperty(_context2 = [i18n.t("account.accountPlan.perks.limitedESignatures"), i18n.t("account.accountPlan.perks.limitedBankStatements"), i18n.t("account.accountPlan.perks.limitedWorkflow"), i18n.t("account.accountPlan.perks.limitedEmail")]).call(_context2, e => e.toString())
  }, {
    key: "pro",
    name: PLAN_NAMES.PRO,
    label: "pro",
    amount: 199,
    perks: _mapInstanceProperty(_context3 = [i18n.t("account.accountPlan.perks.dealAndManagement"), i18n.t("account.accountPlan.perks.applicationPortal"), i18n.t("account.accountPlan.perks.intuitiveDashboard"), i18n.t("account.accountPlan.perks.automatedLenderNotes"), i18n.t("account.accountPlan.perks.automatedClientEmailSummaries"), i18n.t("account.accountPlan.perks.smartEmailDrafts"), i18n.t("account.accountPlan.perks.documentDataExtraction"), i18n.t("account.accountPlan.perks.secureDocumentStorage"), i18n.t("account.accountPlan.perks.integratedCustomerSupport"), i18n.t("account.accountPlan.perks.referralTool"), i18n.t("account.accountPlan.perks.reporting"), i18n.t("account.accountPlan.perks.directToLender"), i18n.t("account.accountPlan.perks.autoSync"), i18n.t("account.accountPlan.perks.unlimitedESignatures"), i18n.t("account.accountPlan.perks.unlimitedBankStatements"), i18n.t("account.accountPlan.perks.unlimitedWorkflow"), i18n.t("account.accountPlan.perks.unlimitedEmail")]).call(_context3, e => e.toString())
  }];
};
export const S3_BUCKET_URL = `https://s3.amazonaws.com/moregidge-${ENVIRONMENT}`;
export const S3_SIGNATURE_BUCKET_URL = `https://s3.amazonaws.com/moregidge-system-emails/${ENVIRONMENT}`;
export const S3_PUBLIC_DOCUMENT_ENDPOINT = "/email/file/signed-s3-url";
export const FORMS_RELATED = {
  "mortgage-app-personal": ["personal-info-form", "identity-form", "married-form", "employment-info-form", "co-applicants-form"],
  "mortgage-app-property": ["get-started-form", "property-details-form", "property-costs-form", "property-styles-form"],
  "mortgage-app-mortgage": ["get-started-form", "mortgage-details-form"]
};
export const SINS = ["sin-1", "sin-2", "sin-3"];
export const COAPP_SINS = number => [`co-applicants[${number}][sin-1]`, `co-applicants[${number}][sin-2]`, `co-applicants[${number}][sin-3]`];
const API_VERSION = !process.env.LOCAL_BACKEND ? "/v1" : "";
export const ACCOUNTS_API = `${process.env.ACCOUNTS_API}${API_VERSION}/accounts`;
export const ACCOUNTS_API_PUBLIC = `${process.env.ACCOUNTS_API}${API_VERSION}`;
export const MAIN_API = `${process.env.MAIN_API}${API_VERSION}`;
export const DOCUMENTS_API = `${process.env.MAIN_API}${API_VERSION}/documents`;
export const SOCKET_URL = `${process.env.WEBSOCKET_API}`;
export const STRIPE_API_KEY = process.env.STRIPE_KEY;
export const NYLAS_API = process.env.NYLAS_API;
export const NYLAS_CLIENT_ID = process.env.NYLAS_CLIENT_ID;
export const EXTERNAL_API = `${process.env.EXTERNAL_API}${API_VERSION}`;
export const BANK_IFRAME_URI = process.env.BANK_IFRAME_URI;
export const TOASTR_OPTIONS = {
  positionClass: "toast-top-center",
  timeOut: 3000,
  extendedTimeOut: 3000,
  showMethod: "slideDown",
  hideMethod: "slideUp",
  closeButton: true,
  hideDuration: 500,
  preventDuplicates: true,
  progressBar: true
};
export const TOASTR_ERROR_OPTIONS = _objectSpread(_objectSpread({}, TOASTR_OPTIONS), {}, {
  timeOut: 5000,
  extendedTimeOut: 5000
});
export const EXTENDED_TOASTR_OPTIONS = _objectSpread(_objectSpread({}, TOASTR_OPTIONS), {}, {
  timeOut: 7000,
  extendedTimeOut: 7000
});
export const NOTIFY_TOASTR_OPTIONS = _objectSpread(_objectSpread({}, TOASTR_OPTIONS), {}, {
  timeOut: undefined,
  extendedTimeOut: undefined,
  progressBar: false
});
export const parseToastTranslationKey = translationKey => {
  var _i18n$t;
  const [key, jsonString = ""] = translationKey.split("|");
  let translationParams = {};
  if (jsonString) {
    try {
      translationParams = JSON.parse(jsonString);
    } catch (_unused) {
      translationParams = {};
    }
  }
  const translationMessage = ((_i18n$t = i18n.t(`notification-messages.${key}`, translationParams)) == null ? void 0 : _i18n$t.toString()) || "";
  return _includesInstanceProperty(translationMessage).call(translationMessage, "notification-messages") ? translationKey : translationMessage;
};
export const clearToast = () => {
  toastr.clear();
};
export const showToast = (type, i18nMessageKey, title, options) => {
  if (type === "success") {
    toastr.success(parseToastTranslationKey(i18nMessageKey), parseToastTranslationKey(title || "success"), _objectSpread(_objectSpread({}, TOASTR_OPTIONS), options));
  }
  if (type === "info") {
    toastr.info(parseToastTranslationKey(i18nMessageKey), parseToastTranslationKey(title || ""), _objectSpread(_objectSpread({}, TOASTR_OPTIONS), options));
  }
  if (type === "error") {
    if (!Vue.auth.ignoreErrorBroadcast) {
      toastr.error(parseToastTranslationKey(i18nMessageKey), parseToastTranslationKey(title || ERROR_HEADER), TOASTR_ERROR_OPTIONS);
    }
    setTimeout(() => {
      Vue.auth.ignoreErrorBroadcast = false;
    }, 200);
  }
};
export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const MINIMUM_TIME_REQUIRED_MONTHS = 36;
export const KEYS_TO_SANITIZE = ["givenName", "familyName", "email", "middleName"];
export const DOCUMENT_CLASSIFICATIONS = {
  "ird-disclosure": "IRD Disclosure",
  "assesment-notice": "Notice of assessment",
  "lenders-commitment": "Lenders Commitment",
  "product-risk-disclosure": "Product Risk Disclosure",
  "mls-listing": "MLS Listing",
  "employment-letter": "Employment Letter",
  "pay-stub": "Pay Stub",
  "downpayment-proof": "Proof of Downpayment",
  "paid-debts-proof": "Proof of Debts Paid",
  "solicitor-info": "Solicitor Information",
  "mortgage-insurance": "Mortgage Insurance",
  appraisal: "Appraisal",
  floorplans: "Floorplans",
  "deposit-receipt": "Deposit Receipt",
  t4: "T4",
  "sale-purchase-agreement": "Purchase And Sale Agreement",
  "borrower-id": "Borrower ID",
  "mortgage-statement": "Mortgage Statement",
  "property-tax-statement": "Property Tax Statement",
  "signed-lease-agreement": "Signed Lease Agreement",
  "t1-general": "T1 General",
  "company-financials": "Company Financials",
  "articles-of-incorporation": "Articles of Incorporation",
  "separation-or-divorce-agreement": "Separation or Divorce Agreement",
  "child-tax-credit-confirmation": "Child Tax Credit Confirmation",
  "copy-of-void-cheque": "Copy of void cheque",
  other: "Unclassified"
};
export const DOCUMENT_CLASSIFICATIONS_FR = {
  "ird-disclosure": "Divulgation IRD",
  "assesment-notice": "Avis de cotisation",
  "lenders-commitment": "Engagement du prêteur",
  "product-risk-disclosure": "Divulgation des risques liés aux produits",
  "mls-listing": "Inscription MLS",
  "employment-letter": "Lettre d’emploi",
  "pay-stub": "Talon de chèque de paie",
  "downpayment-proof": "Preuve de mise de fonds",
  "paid-debts-proof": "Preuve des dettes payées",
  "solicitor-info": "Renseignements sur l’avocat",
  "mortgage-insurance": "Assurance prêt hypothécaire",
  appraisal: "Estimé",
  floorplans: "Plans d’étage",
  "deposit-receipt": "Reçu de dépôt",
  t4: "T4",
  "sale-purchase-agreement": "Entente d’achat et de vente",
  "borrower-id": "Identifiant de l’emprunteur",
  "mortgage-statement": "Relevé de prêt hypothécaire",
  "property-tax-statement": "Déclaration de taxe foncière",
  "signed-lease-agreement": "Contrat de location signé",
  "t1-general": "T1 Général",
  "company-financials": "Données financières de l’entreprise",
  "articles-of-incorporation": "Statuts constitutifs",
  "separation-or-divorce-agreement": "Entente de séparation ou de divorce",
  "child-tax-credit-confirmation": "Confirmation du crédit d’impôt pour enfants",
  "copy-of-void-cheque": "Copie de chèque annulé",
  other: "Autre"
};
export const DEFAULT_DOCUMENT_CLASSIFICATIONS = ["Appraisal", "Articles of Incorporation", "Borrower ID", "Child Tax Credit Confirmation", "Company Financials", "Copy of void Cheque", "Deposit Receipt", "Employment Letter", "Floorplans", "IRD Disclosure", "Lender Commitment", "MLS Listing", "Mortgage Insurance", "Mortgage Statement", "Notice of Assessment ", "Other", "Pay Stub", "Product Risk Disclosure", "Proof of Debts Paid", "Proof of Downpayment", "Property Tax Statement", "Purchase and Sale Agreement", "Separation or Divorce Agreement", "Signed Lease Agreement", "Solicitor Information", "T1 General", "T4"];
export const EMAIL_PREFERENCES = {
  client: {
    promotional: "Send promotional communications from Expert Pro?",
    newComment: "Send an email for any new comment by my Agent or Broker?",
    requestedDocument: "Send an email for any document requested by my Agent or Broker?",
    uploadedDocument: "Send an email for any new uploaded document by my Agent or Broker?",
    mortgageApplication: "Send an email when there is a change in status of my application?"
  },
  broker: {
    promotional: "Send promotional communications from Expert Pro?",
    newComment: "Send an email for any new comment?",
    uploadedDocument: "Send an email for any new uploaded document?",
    clientRegistration: "Send an email for any new client registration?",
    mortgageApplication: "Send an email for any submission of a mortgage application?",
    followUpReminder: "Send an email alert for a scheduled activity?",
    lenderSubmissionResponse: "Send an email for any lender submission response of a mortgage application?"
  }
};
export const MONTHS_NAMES = () => _Object$values(i18n.t("global.months"));
export const GENERIC_LOAD_ERROR = "There was an error while loading this information. Please, Try Again.";
export const parseParams = (params = {}) => {
  const parsedParams = _objectSpread({}, params);
  if (!isEmpty(parsedParams)) {
    for (const key in parsedParams) {
      const param = parsedParams[key];
      if (param == null || param === "") delete parsedParams[key];
    }
    return `?${$.param(parsedParams)}`;
  }
  return "";
};
export const EMAIL_TEMPLATE_TYPES = {
  DOCUMENT_REQUEST: "document-request",
  CLIENT_PROFILE: "client-profile"
};
export const GENERATED_PDF_CLASIFICATION_TYPE = () => i18n.t("documents.generatedPDFClassification");
export const SUPPORTED_BROWSERS = [{
  name: "Chrome",
  version: 49,
  supportedOn: ["client", "broker"],
  recommended: true
}, {
  name: "Firefox",
  version: 61,
  supportedOn: ["client", "broker"],
  recommended: true
}, {
  name: "Opera",
  version: 36,
  supportedOn: ["client", "broker"],
  recommended: true
}, {
  name: "Safari",
  version: 11,
  supportedOn: ["client", "broker"],
  recommended: true
}, {
  name: "IE",
  version: 11,
  supportedOn: ["client"],
  recommended: false
}, {
  name: "Edge",
  version: 18,
  supportedOn: ["client"],
  recommended: false
}];
export const SELECT2_DEFAULTS = {
  dropdownCssClass: "sm form-group-material",
  containerCssClass: "sm"
};
export const PROVINCE_SELECT_OPTIONS = () => [{
  value: "Alberta",
  label: i18n.t("address.provinces.alberta")
}, {
  value: "British Columbia",
  label: i18n.t("address.provinces.britishColumbia")
}, {
  value: "Manitoba",
  label: i18n.t("address.provinces.manitoba")
}, {
  value: "New Brunswick",
  label: i18n.t("address.provinces.newBrunswick")
}, {
  value: "Newfoundland and Labrador",
  label: i18n.t("address.provinces.newfoundlandAndLabrador")
}, {
  value: "Nova Scotia",
  label: i18n.t("address.provinces.novaScotia")
}, {
  value: "Northwest Territories",
  label: i18n.t("address.provinces.northwestTerritories")
}, {
  value: "Nunavut",
  label: i18n.t("address.provinces.nunavut")
}, {
  value: "Ontario",
  label: i18n.t("address.provinces.ontario")
}, {
  value: "Prince Edward Island",
  label: i18n.t("address.provinces.princeEdwardIsland")
}, {
  value: "Québec",
  label: i18n.t("address.provinces.quebec")
}, {
  value: "Saskatchewan",
  label: i18n.t("address.provinces.saskatchewan")
}, {
  value: "Yukon",
  label: i18n.t("address.provinces.yukon")
}];
export const REFERRER_TYPE_OPTIONS = () => [{
  id: "accountant",
  text: i18n.t("referrers.referrerType.accountant")
}, {
  id: "appraisor",
  text: i18n.t("referrers.referrerType.appraisor")
}, {
  id: "bankruptcy-trustee",
  text: i18n.t("referrers.referrerType.bankruptcy-trustee")
}, {
  id: "broker-compliance",
  text: i18n.t("referrers.referrerType.broker-compliance")
}, {
  id: "broker-fulfillment",
  text: i18n.t("referrers.referrerType.broker-fulfillment")
}, {
  id: "brokerage-administrator",
  text: i18n.t("referrers.referrerType.brokerage-administrator")
}, {
  id: "brokerage-bdm",
  text: i18n.t("referrers.referrerType.brokerage-bdm")
}, {
  id: "brokerage-co-agent",
  text: i18n.t("referrers.referrerType.brokerage-co-agent")
}, {
  id: "brokerage-underwriter",
  text: i18n.t("referrers.referrerType.brokerage-underwriter")
}, {
  id: "builder-developer",
  text: i18n.t("referrers.referrerType.builder-developer")
}, {
  id: "consultant",
  text: i18n.t("referrers.referrerType.consultant")
}, {
  id: "credit-counsellor",
  text: i18n.t("referrers.referrerType.credit-counsellor")
}, {
  id: "financial-advisor",
  text: i18n.t("referrers.referrerType.financial-advisor")
}, {
  id: "inspector",
  text: i18n.t("referrers.referrerType.inspector")
}, {
  id: "insurance-agent",
  text: i18n.t("referrers.referrerType.insurance-agent")
}, {
  id: "insurance-broker",
  text: i18n.t("referrers.referrerType.insurance-broker")
}, {
  id: "lawyer",
  text: i18n.t("referrers.referrerType.lawyer")
}, {
  id: "lender-bdm",
  text: i18n.t("referrers.referrerType.lender-bdm")
}, {
  id: "lender-partner",
  text: i18n.t("referrers.referrerType.lender-partner")
}, {
  id: "lender-underwriter",
  text: i18n.t("referrers.referrerType.lender-underwriter")
}, {
  id: "mortgage-agent-associate-broker",
  text: i18n.t("referrers.referrerType.mortgage-agent-associate-broker")
}, {
  id: "notary",
  text: i18n.t("referrers.referrerType.notary")
}, {
  id: "other",
  text: i18n.t("referrers.referrerType.other")
}, {
  id: "past-client",
  text: i18n.t("referrers.referrerType.past-client")
}, {
  id: "property-manager",
  text: i18n.t("referrers.referrerType.property-manager")
}, {
  id: "realtor",
  text: i18n.t("referrers.referrerType.realtor")
}, {
  id: "renovator-contractor",
  text: i18n.t("referrers.referrerType.renovator-contractor")
}, {
  id: "social-media",
  text: i18n.t("referrers.referrerType.social-media")
}, {
  id: "title-company",
  text: i18n.t("referrers.referrerType.title-company")
}, {
  id: "wealth-manager",
  text: i18n.t("referrers.referrerType.wealth-manager")
}];
export const FORMS_SUBMISSION_DEPENDANT = ["mortgageApplication", "mortgageSummary"];
export const CAMPAIGNS_STATUS = () => ({
  sent: i18n.t("campaigns.status.sent"),
  active: i18n.t("campaigns.status.active"),
  cancelled: i18n.t("campaigns.status.cancelled")
});
export const TOS_EXTERNAL_LINK = () => i18n.locale === "fr-CA" ? "https://www.finastracanada.com/sites/default/files/2023-08/Expert_Plus_Pro_Terms_FR.pdf" : "https://www.finastracanada.com/sites/default/files/2023-08/Expert_Plus_Pro_Terms_EN.pdf";
export const PRIVACY_EXTERNAL_LINK = () => i18n.locale === "fr-CA" ? "/privacy-policy-fr.html" : "/privacy-policy-en.html";
export const PERSONAL_DETAILS = () => ({
  givenName: i18n.t("account.givenName"),
  middleName: i18n.t("account.middleName"),
  familyName: i18n.t("account.familyName"),
  phoneNumber: i18n.t("account.phoneNumber"),
  altPhoneNumber: i18n.t("account.altPhoneNumber"),
  streetNumber: i18n.t("global.doorr.streetNumber"),
  streetName: i18n.t("global.doorr.streetName"),
  unitNumber: i18n.t("global.doorr.unitNumber"),
  province: i18n.t("global.words.province"),
  city: i18n.t("global.words.city"),
  postalCode: i18n.t("global.doorr.postalCode")
});
export const LENDER_SUBMISSION_DETAILS = () => ({
  firmCode: i18n.t("settings.accountTab.firmCode"),
  expertLoginId: i18n.t("settings.accountTab.expertLoginId"),
  licenseRegistrationNumber: i18n.t("settings.accountTab.licenseRegistrationNumber"),
  applicationAccessRights: i18n.t("settings.accountTab.applicationAccessRights")
});
export const FILOGIX_STATUSES = {
  "in-progress": 0,
  "ready-to-submit": 5,
  submitted: 15,
  declined: 20,
  pending: 25,
  approved: 30,
  accepted: 35,
  "ready-to-close": 40,
  closed: 45,
  confirmed: 47,
  paid: 50,
  completed: 55,
  rejected: 70,
  cancelled: 60
};
export const APPLICATION_SYNC_ERRORS = ["AGENT_NOT_VERIFIED", "AGENT_MISCONFIGURED", "SUBMISSION_AGENT_MISCONFIGURED", "PAYLOAD_VALIDATION", "DEAL_LOCKED", "INTERNAL_ERROR"];
export const APPLICATION_TYPE_OPTIONS = () => [{
  text: i18n.t("application-form.approval"),
  id: "approval"
}, {
  text: i18n.t("application-form.pre-approval"),
  id: "pre-approval"
}];
export const RESPONSE_TIME_THRESHOLD_MILLISECONDS = 2000;
export const DOCUMENT_STATUSES = ["complete", "toBeReviewed", "flagged", "pendingVerification", "rejected"];
export const documentStatusIcons = {
  complete: "fa fa-check-circle text-success",
  toBeReviewed: "fa fa-clock-o text-warning",
  flagged: "fa fa-bookmark text-info",
  pendingVerification: "fa fa-search text-primary",
  rejected: "fa fa-times text-danger"
};
export const streetTypeAbrvs = {
  ALLEE: "ALLEY",
  ALLEY: "ALLEY",
  ALLY: "ALLEY",
  ALY: "ALLEY",
  ANEX: "ANNEX",
  ANNEX: "ANNEX",
  ANNX: "ANNEX",
  ANX: "ANNEX",
  ARC: "ARCADE",
  ARCADE: "ARCADE",
  AV: "AVENUE",
  AVE: "AVENUE",
  AVEN: "AVENUE",
  AVENU: "AVENUE",
  AVENUE: "AVENUE",
  AVN: "AVENUE",
  AVNUE: "AVENUE",
  BAYOO: "BAYOU",
  BAYOU: "BAYOU",
  BYU: "BAYOU",
  BCH: "BEACH",
  BEACH: "BEACH",
  BEND: "BEND",
  BND: "BEND",
  BLF: "BLUFF",
  BLUF: "BLUFF",
  BLUFF: "BLUFF",
  BLUFFS: "BLUFFS",
  BLFS: "BLUFFS",
  BOT: "BOTTOM",
  BTM: "BOTTOM",
  BOTTM: "BOTTOM",
  BOTTOM: "BOTTOM",
  BLVD: "BOULEVARD",
  BOUL: "BOULEVARD",
  BOULEVARD: "BOULEVARD",
  BOULV: "BOULEVARD",
  BR: "BRANCH",
  BRNCH: "BRANCH",
  BRANCH: "BRANCH",
  BRDGE: "BRIDGE",
  BRG: "BRIDGE",
  BRIDGE: "BRIDGE",
  BRK: "BROOK",
  BROOK: "BROOK",
  BROOKS: "BROOKS",
  BRKS: "BROOKS",
  BURG: "BURG",
  BG: "BURG",
  BURGS: "BURGS",
  BGS: "BURGS",
  BYP: "BYPASS",
  BYPA: "BYPASS",
  BYPAS: "BYPASS",
  BYPASS: "BYPASS",
  BYPS: "BYPASS",
  CAMP: "CAMP",
  CP: "CAMP",
  CMP: "CAMP",
  CANYN: "CANYON",
  CANYON: "CANYON",
  CNYN: "CANYON",
  CYN: "CANYON",
  CAPE: "CAPE",
  CPE: "CAPE",
  CAUSEWAY: "CAUSEWAY",
  CAUSWA: "CAUSEWAY",
  CSWY: "CAUSEWAY",
  CEN: "CENTER",
  CENT: "CENTER",
  CENTER: "CENTER",
  CENTR: "CENTER",
  CENTRE: "CENTER",
  CNTER: "CENTER",
  CNTR: "CENTER",
  CTR: "CENTER",
  CENTERS: "CENTERS",
  CTRS: "CENTERS",
  CIR: "CIRCLE",
  CIRC: "CIRCLE",
  CIRCL: "CIRCLE",
  CIRCLE: "CIRCLE",
  CRCL: "CIRCLE",
  CRCLE: "CIRCLE",
  CIRCLES: "CIRCLES",
  CIRS: "CIRCLES",
  CLF: "CLIFF",
  CLIFF: "CLIFF",
  CLFS: "CLIFFS",
  CLIFFS: "CLIFFS",
  CLB: "CLUB",
  CLUB: "CLUB",
  COMMON: "COMMON",
  CMN: "COMMON",
  COMMONS: "COMMONS",
  CMNS: "COMMONS",
  COR: "CORNER",
  CORNER: "CORNER",
  CORNERS: "CORNERS",
  CORS: "CORNERS",
  COURSE: "COURSE",
  CRSE: "COURSE",
  COURT: "COURT",
  CT: "COURT",
  COURTS: "COURTS",
  CTS: "COURTS",
  COVE: "COVE",
  CV: "COVE",
  COVES: "COVES",
  CVS: "COVES",
  CREEK: "CREEK",
  CRK: "CREEK",
  CRESCENT: "CRESCENT",
  CRES: "CRESCENT",
  CRSENT: "CRESCENT",
  CRSNT: "CRESCENT",
  CREST: "CREST",
  CRST: "CREST",
  CROSSING: "CROSSING",
  CRSSNG: "CROSSING",
  XING: "CROSSING",
  CROSSROAD: "CROSSROAD",
  XRD: "CROSSROAD",
  CROSSROADS: "CROSSROADS",
  XRDS: "CROSSROADS",
  CURVE: "CURVE",
  CURV: "CURVE",
  CRV: "CURVE",
  CRVE: "CURVE",
  DALE: "DALE",
  DL: "DALE",
  DAM: "DAM",
  DM: "DAM",
  DIV: "DIVIDE",
  DIVIDE: "DIVIDE",
  DV: "DIVIDE",
  DVD: "DIVIDE",
  DR: "DRIVE",
  DRIV: "DRIVE",
  DRIVE: "DRIVE",
  DRV: "DRIVE",
  DRIVES: "DRIVES",
  DRS: "DRIVES",
  EST: "ESTATE",
  ESTATE: "ESTATE",
  ESTATES: "ESTATES",
  ESTS: "ESTATES",
  EXP: "EXPRESSWAY",
  EXPR: "EXPRESSWAY",
  EXPRESS: "EXPRESSWAY",
  EXPRESSWAY: "EXPRESSWAY",
  EXPW: "EXPRESSWAY",
  EXPY: "EXPRESSWAY",
  EXT: "EXTENSION",
  EXTENSION: "EXTENSION",
  EXTN: "EXTENSION",
  EXTNSN: "EXTENSION",
  EXTS: "EXTENSIONS",
  FALL: "FALL",
  FALLS: "FALLS",
  FLS: "FALLS",
  FERRY: "FERRY",
  FRRY: "FERRY",
  FRY: "FERRY",
  FIELD: "FIELD",
  FLD: "FIELD",
  FIELDS: "FIELDS",
  FLDS: "FIELDS",
  FLAT: "FLAT",
  FLT: "FLAT",
  FLATS: "FLATS",
  FLTS: "FLATS",
  FORD: "FORD",
  FRD: "FORD",
  FORDS: "FORDS",
  FRDS: "FORDS",
  FOREST: "FOREST",
  FORESTS: "FOREST",
  FRST: "FOREST",
  FORG: "FORGE",
  FORGE: "FORGE",
  FRG: "FORGE",
  FORGES: "FORGES",
  FRGS: "FORGES",
  FORK: "FORK",
  FRK: "FORK",
  FORKS: "FORKS",
  FRKS: "FORKS",
  FORT: "FORT",
  FRT: "FORT",
  FT: "FORT",
  FREEWAY: "FREEWAY",
  FREEWY: "FREEWAY",
  FRWAY: "FREEWAY",
  FRWY: "FREEWAY",
  FWY: "FREEWAY",
  GARDEN: "GARDEN",
  GARDN: "GARDEN",
  GRDEN: "GARDEN",
  GRDN: "GARDEN",
  GDN: "GARDEN",
  GARDENS: "GARDENS",
  GDNS: "GARDENS",
  GRDNS: "GARDENS",
  GATEWAY: "GATEWAY",
  GATEWY: "GATEWAY",
  GATWAY: "GATEWAY",
  GTWAY: "GATEWAY",
  GTWY: "GATEWAY",
  GATE: "GATE",
  GLEN: "GLEN",
  GLN: "GLEN",
  GLENS: "GLENS",
  GLNS: "GLENS",
  GREEN: "GREEN",
  GRN: "GREEN",
  GREENS: "GREENS",
  GRNS: "GREENS",
  GROV: "GROVE",
  GROVE: "GROVE",
  GRV: "GROVE",
  GROVES: "GROVES",
  GRVS: "GROVES",
  HARB: "HARBOR",
  HARBOR: "HARBOR",
  HARBR: "HARBOR",
  HBR: "HARBOR",
  HRBOR: "HARBOR",
  HARBORS: "HARBORS",
  HBRS: "HARBORS",
  HAVEN: "HAVEN",
  HVN: "HAVEN",
  HT: "HEIGHTS",
  HTS: "HEIGHTS",
  HIGHWAY: "HIGHWAY",
  HIGHWY: "HIGHWAY",
  HIWAY: "HIGHWAY",
  HIWY: "HIGHWAY",
  HWAY: "HIGHWAY",
  HWY: "HIGHWAY",
  HILL: "HILL",
  HL: "HILL",
  HILLS: "HILLS",
  HLS: "HILLS",
  HLLW: "HOLLOW",
  HOLLOW: "HOLLOW",
  HOLLOWS: "HOLLOW",
  HOLW: "HOLLOW",
  HOLWS: "HOLLOW",
  INLT: "INLET",
  IS: "ISLAND",
  ISLAND: "ISLAND",
  ISLND: "ISLAND",
  ISLANDS: "ISLANDS",
  ISLNDS: "ISLANDS",
  ISS: "ISLANDS",
  ISLE: "ISLE",
  ISLES: "ISLE",
  JCT: "JUNCTION",
  JCTION: "JUNCTION",
  JCTN: "JUNCTION",
  JUNCTION: "JUNCTION",
  JUNCTN: "JUNCTION",
  JUNCTON: "JUNCTION",
  JCTNS: "JUNCTIONS",
  JCTS: "JUNCTIONS",
  JUNCTIONS: "JUNCTIONS",
  KEY: "KEY",
  KY: "KEY",
  KEYS: "KEYS",
  KYS: "KEYS",
  KNL: "KNOLL",
  KNOL: "KNOLL",
  KNOLL: "KNOLL",
  KNLS: "KNOLLS",
  KNOLLS: "KNOLLS",
  LK: "LAKE",
  LAKE: "LAKE",
  LKS: "LAKES",
  LAKES: "LAKES",
  LAND: "LAND",
  LANDING: "LANDING",
  LNDG: "LANDING",
  LNDNG: "LANDING",
  LANE: "LANE",
  LN: "LANE",
  LGT: "LIGHT",
  LIGHT: "LIGHT",
  LIGHTS: "LIGHTS",
  LGTS: "LIGHTS",
  LF: "LOAF",
  LOAF: "LOAF",
  LCK: "LOCK",
  LOCK: "LOCK",
  LCKS: "LOCKS",
  LOCKS: "LOCKS",
  LDG: "LODGE",
  LDGE: "LODGE",
  LODG: "LODGE",
  LODGE: "LODGE",
  LOOP: "LOOP",
  LOOPS: "LOOP",
  MALL: "MALL",
  MNR: "MANOR",
  MANOR: "MANOR",
  MANORS: "MANORS",
  MNRS: "MANORS",
  MEADOW: "MEADOW",
  MDW: "MEADOWS",
  MDWS: "MEADOWS",
  MEADOWS: "MEADOWS",
  MEDOWS: "MEADOWS",
  MEWS: "MEWS",
  MILL: "MILL",
  ML: "MILL",
  MILLS: "MILLS",
  MLS: "MILLS",
  MISSN: "MISSION",
  MSSN: "MISSION",
  MSN: "MISSION",
  MOTORWAY: "MOTORWAY",
  MTWY: "MOTORWAY",
  MNT: "MOUNT",
  MT: "MOUNT",
  MOUNT: "MOUNT",
  MNTAIN: "MOUNTAIN",
  MNTN: "MOUNTAIN",
  MOUNTAIN: "MOUNTAIN",
  MOUNTIN: "MOUNTAIN",
  MTIN: "MOUNTAIN",
  MTN: "MOUNTAIN",
  MNTNS: "MOUNTAINS",
  MOUNTAINS: "MOUNTAINS",
  MTNS: "MOUNTAINS",
  NCK: "NECK",
  NECK: "NECK",
  ORCH: "ORCHARD",
  ORCHARD: "ORCHARD",
  ORCHRD: "ORCHARD",
  OVAL: "OVAL",
  OVL: "OVAL",
  OVERPASS: "OVERPASS",
  OPAS: "OVERPASS",
  PARK: "PARKS",
  PRK: "PARK",
  PARKS: "PARKS",
  PARKWAY: "PARKWAY",
  PARKWY: "PARKWAY",
  PKWAY: "PARKWAY",
  PKWY: "PARKWAYS",
  PKY: "PARKWAY",
  PARKWAYS: "PARKWAYS",
  PKWYS: "PARKWAYS",
  PASS: "PASS",
  PASSAGE: "PASSAGE",
  PSGE: "PASSAGE",
  PATH: "PATH",
  PATHS: "PATH",
  PIKE: "PIKE",
  PIKES: "PIKE",
  PINE: "PINE",
  PNE: "PINE",
  PINES: "PINES",
  PNES: "PINES",
  PL: "PLACE",
  PLACE: "PLACE",
  PLAIN: "PLAIN",
  PLN: "PLAIN",
  PLAINS: "PLAINS",
  PLNS: "PLAINS",
  PLAZA: "PLAZA",
  PLZ: "PLAZA",
  PLZA: "PLAZA",
  POINT: "POINT",
  PT: "POINT",
  POINTS: "POINTS",
  PTS: "POINTS",
  PORT: "PORT",
  PRT: "PORT",
  PORTS: "PORTS",
  PRTS: "PORTS",
  PR: "PRAIRIE",
  PRAIRIE: "PRAIRIE",
  PRR: "PRAIRIE",
  RAD: "RADIAL",
  RADIAL: "RADIAL",
  RADIEL: "RADIAL",
  RADL: "RADIAL",
  RAMP: "RAMP",
  RANCH: "RANCH",
  RANCHES: "RANCH",
  RNCH: "RANCH",
  RNCHS: "RANCH",
  RAPID: "RAPID",
  RPD: "RAPID",
  RAPIDS: "RAPIDS",
  RPDS: "RAPIDS",
  REST: "REST",
  RST: "REST",
  RDG: "RIDGE",
  RDGE: "RIDGE",
  RIDGE: "RIDGE",
  RDGS: "RIDGES",
  RIDGES: "RIDGES",
  RIV: "RIVER",
  RIVER: "RIVER",
  RVR: "RIVER",
  RIVR: "RIVER",
  RD: "ROAD",
  ROAD: "ROAD",
  ROADS: "ROADS",
  RDS: "ROADS",
  ROUTE: "ROUTE",
  RTE: "ROUTE",
  ROW: "ROW",
  RUE: "RUE",
  RUN: "RUN",
  SHL: "SHOAL",
  SHOAL: "SHOAL",
  SHLS: "SHOALS",
  SHOALS: "SHOALS",
  SHOAR: "SHORE",
  SHORE: "SHORE",
  SHR: "SHORE",
  SHOARS: "SHORES",
  SHORES: "SHORES",
  SHRS: "SHORES",
  SKYWAY: "SKYWAY",
  SKWY: "SKYWAY",
  SPG: "SPRING",
  SPNG: "SPRING",
  SPRING: "SPRING",
  SPRNG: "SPRING",
  SPGS: "SPRINGS",
  SPNGS: "SPRINGS",
  SPRINGS: "SPRINGS",
  SPRNGS: "SPRINGS",
  SPUR: "SPURS",
  SPURS: "SPURS",
  SQ: "SQUARE",
  SQR: "SQUARE",
  SQRE: "SQUARE",
  SQU: "SQUARE",
  SQUARE: "SQUARE",
  SQRS: "SQUARES",
  SQUARES: "SQUARES",
  SQS: "SQUARES",
  STA: "STATION",
  STATION: "STATION",
  STATN: "STATION",
  STN: "STATION",
  STRA: "STRAVENUE",
  STRAV: "STRAVENUE",
  STRAVEN: "STRAVENUE",
  STRAVENUE: "STRAVENUE",
  STRAVN: "STRAVENUE",
  STRVN: "STRAVENUE",
  STRVNUE: "STRAVENUE",
  STREAM: "STREAM",
  STREME: "STREAM",
  STRM: "STREAM",
  STREET: "STREET",
  STRT: "STREET",
  ST: "STREET",
  STR: "STREET",
  STREETS: "STREETS",
  STS: "STREETS",
  SMT: "SUMMIT",
  SUMIT: "SUMMIT",
  SUMITT: "SUMMIT",
  SUMMIT: "SUMMIT",
  TER: "TERRACE",
  TERR: "TERRACE",
  TERRACE: "TERRACE",
  THROUGHWAY: "THROUGHWAY",
  TRWY: "THROUGHWAY",
  TRACE: "TRACE",
  TRACES: "TRACE",
  TRCE: "TRACE",
  TRACK: "TRACK",
  TRACKS: "TRACK",
  TRAK: "TRACK",
  TRK: "TRACK",
  TRKS: "TRACK",
  TRAFFICWAY: "TRAFFICWAY",
  TRFY: "TRAFFICWAY",
  TRAIL: "TRAIL",
  TRAILS: "TRAIL",
  TRL: "TRAIL",
  TRLS: "TRAIL",
  TRAILER: "TRAILER",
  TRLR: "TRAILER",
  TRLRS: "TRAILER",
  TUNEL: "TUNNEL",
  TUNL: "TUNNEL",
  TUNLS: "TUNNEL",
  TUNNEL: "TUNNEL",
  TUNNELS: "TUNNEL",
  TUNNL: "TUNNEL",
  TRNPK: "TURNPIKE",
  TURNPIKE: "TURNPIKE",
  TURNPK: "TURNPIKE",
  TPKE: "TURNPIKE",
  UNDERPASS: "UNDERPASS",
  UPAS: "UNDERPASS",
  UN: "UNION",
  UNION: "UNION",
  UNIONS: "UNIONS",
  UNS: "UNIONS",
  VALLEY: "VALLEY",
  VALLY: "VALLEY",
  VLLY: "VALLEY",
  VLY: "VALLEY",
  VALLEYS: "VALLEYS",
  VLYS: "VALLEYS",
  VDCT: "VIADUCT",
  VIA: "VIADUCT",
  VIADCT: "VIADUCT",
  VIADUCT: "VIADUCT",
  VIEW: "VIEW",
  VW: "VIEW",
  VIEWS: "VIEWS",
  VWS: "VIEWS",
  VILL: "VILLAGE",
  VILLAG: "VILLAGE",
  VILLAGE: "VILLAGE",
  VILLG: "VILLAGE",
  VILLIAGE: "VILLAGE",
  VLG: "VILLAGE",
  VILLAGES: "VILLAGES",
  VLGS: "VILLAGES",
  VILLE: "VILLE",
  VL: "VILLE",
  VIS: "VISTA",
  VIST: "VISTA",
  VISTA: "VISTA",
  VST: "VISTA",
  VSTA: "VISTA",
  WALK: "WALKS",
  WALKS: "WALKS",
  WALL: "WALL",
  WY: "WAY",
  WAY: "WAY",
  WAYS: "WAYS",
  WELL: "WELL",
  WL: "WELL",
  WELLS: "WELLS",
  WLS: "WELLS",
  ABBEY: "ABBEY",
  ACRES: "ACRES",
  AUTOROUTE: "AUTOROUTE",
  BAY: "BAY",
  BYWAY: "BYWAY",
  CAMPUS: "CAMPUS",
  CARRÉ: "CARRÉ",
  CARREFOUR: "CARREFOUR",
  CERCLE: "CERCLE",
  CHASE: "CHASE",
  CHEMIN: "CHEMIN",
  CIRCUIT: "CIRCUIT",
  CLOSE: "CLOSE",
  CONCESSION: "CONCESSION",
  CÔTE: "CÔTE",
  COUR: "COUR",
  COURS: "COURS",
  CROISSANT: "CROISSANT",
  "CUL-DE-SAC": "CUL-DE-SAC",
  DELL: "DELL",
  DIVERSION: "DIVERSION",
  DOWNS: "DOWNS",
  ÉCHANGEUR: "ÉCHANGEUR",
  END: "END",
  ESPLANADE: "ESPLANADE",
  FRONT: "FRONT",
  GLADE: "GLADE",
  GROUNDS: "GROUNDS",
  HEATH: "HEATH",
  HIGHLANDS: "HIGHLANDS",
  ÎLE: "ÎLE",
  IMPASSE: "IMPASSE",
  LIMITS: "LIMITS",
  LINE: "LINE",
  LINK: "LINK",
  LOOKOUT: "LOOKOUT",
  MAZE: "MAZE",
  MONTÉE: "MONTÉE",
  MOOR: "MOOR",
  PARADE: "PARADE",
  PARC: "PARC",
  PATHWAY: "PATHWAY",
  PLATEAU: "PLATEAU",
  POINTE: "POINTE",
  PRIVATE: "PRIVATE",
  PROMENADE: "PROMENADE",
  QUAI: "QUAI",
  QUAY: "QUAY",
  RANG: "RANG",
  RANGE: "RANGE",
  RISE: "RISE",
  "ROND-POINT": "ROND-POINT",
  RUELLE: "RUELLE",
  SENTIER: "SENTIER",
  SUBDIVISION: "SUBDIVISION",
  TERRASSE: "TERRASSE",
  THICKET: "THICKET",
  TOWERS: "TOWERS",
  TOWNLINE: "TOWNLINE",
  TURNABOUT: "TURNABOUT",
  VALE: "VALE",
  VILLAS: "VILLAS",
  VOIE: "VOIE",
  WHARF: "WHARF",
  WOOD: "WOOD",
  WYND: "WYND"
};